// import React from "react";
// import { GoTriangleLeft } from "react-icons/go";
// import { RxTriangleRight } from "react-icons/rx";
// import { useTranslation } from "../../hooks/useTranslation";

// function Pagination({ page, totalPages, setPage }) {
//   const { t } = useTranslation();
//   return (
//     <div className="grid sm:grid-cols-2 gap-3 sm:justify-between justify-center items-center bg-white border-t border-[#F0F1F3] py-4 px-5 w-full max-w-[100%] rounded-b-[10px]">
//       <p className="text-[#667085] text-[17.8px] font-normal basis-1/2 sm:text-left text-center">
//         {t("admindashboard")
//           .pagination.replace("{{page}}", page)
//           .replace("{{totalPages}}", totalPages)}
//       </p>

//       <div className="flex items-center space-x-2 justify-end text-right">
//         <button
//           className={`w-8 h-8 flex items-center justify-center rounded-md ${
//             page === 1
//               ? "bg-gray-300 cursor-not-allowed"
//               : "bg-[#F4ECFB] hover:bg-purple-200"
//           } text-black`}
//           onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
//           disabled={page === 1}
//         >
//           <GoTriangleLeft />
//         </button>

//         {Array.from({ length: totalPages }, (_, index) => (
//           <button
//             key={index}
//             className={`w-8 h-8 flex items-center justify-center rounded-md ${
//               page === index + 1
//                 ? "bg-[#4CAF50] text-white"
//                 : "bg-gray-200 hover:bg-gray-300 text-black"
//             }`}
//             onClick={() => setPage(index + 1)}
//           >
//             {index + 1}
//           </button>
//         ))}

//         <button
//           className={`w-8 h-8 flex items-center justify-center rounded-md ${
//             page === totalPages
//               ? "bg-gray-300 cursor-not-allowed"
//               : "bg-[#F4ECFB] hover:bg-purple-200"
//           } text-black`}
//           onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
//           disabled={page === totalPages}
//         >
//           <RxTriangleRight />
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Pagination;


import React from "react";
import { GoTriangleLeft } from "react-icons/go";
import { RxTriangleRight } from "react-icons/rx";
import { useTranslation } from "../../hooks/useTranslation";

function Pagination({ page, totalPages, setPage }) {
  const { t } = useTranslation();

  const getPageNumbers = () => {
    const delta = 1; // pages around current
    const range = [];
    const rangeWithDots = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - delta && i <= page + delta)) {
        range.push(i);
      }
    }

    let last = 0;
    for (let i of range) {
      if (i - last > 1) {
        rangeWithDots.push("...");
      }
      rangeWithDots.push(i);
      last = i;
    }

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="grid sm:grid-cols-2 gap-3 sm:justify-between justify-center items-center bg-white border-t border-[#F0F1F3] py-4 px-5 w-full max-w-[100%] rounded-b-[10px]">
      <p className="text-[#667085] text-[17.8px] font-normal basis-1/2 sm:text-left text-center">
        {t("admindashboard")
          .pagination.replace("{{page}}", page)
          .replace("{{totalPages}}", totalPages)}
      </p>

      <div className="flex items-center space-x-2 justify-end text-right">
        {/* Previous Button */}
        <button
          className={`w-8 h-8 flex items-center justify-center rounded-md ${
            page === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-[#F4ECFB] hover:bg-purple-200"
          } text-black`}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          <GoTriangleLeft />
        </button>

        {/* Page Buttons */}
        {pageNumbers.map((num, idx) =>
          num === "..." ? (
            <span key={idx} className="w-8 h-8 flex items-center justify-center text-black">
              ...
            </span>
          ) : (
            <button
              key={idx}
              className={`w-8 h-8 flex items-center justify-center rounded-md ${
                page === num ? "bg-[#4CAF50] text-white" : "bg-gray-200 hover:bg-gray-300 text-black"
              }`}
              onClick={() => setPage(num)}
            >
              {num}
            </button>
          )
        )}

        {/* Next Button */}
        <button
          className={`w-8 h-8 flex items-center justify-center rounded-md ${
            page === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-[#F4ECFB] hover:bg-purple-200"
          } text-black`}
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={page === totalPages}
        >
          <RxTriangleRight />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
